module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1007-449e0cd0ca0711658d6242944fe92be7.png";